const getUniqueListBy = <T>(arr: T[], key: string): T[] => [
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ...new Map(arr.map(item => [item[key], item])).values(),
];

export default getUniqueListBy;
